import React from 'react';

const PlatformCard = ({ 
  children, 
  className = '', 
  style = {},
  variant = 'default',
  padding = 'medium',
  ...props 
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = 'card';
    const paddingClass = padding !== 'medium' ? `padding-${padding}` : '';
    const variantClass = variant !== 'default' ? `variant-${variant}` : '';
    
    return [baseClass, paddingClass, variantClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {};
    
    // Only add styles that CANNOT be handled by CSS
    return { ...styles, ...style };
  };

  return (
    <div 
      className={getClassName()}
      style={getInlineStyles()}
      {...props}
    >
      {children}
    </div>
  );
};

export default PlatformCard; 